import { fontFamily } from "../../../../app/theme";
import { NumericFormat } from "react-number-format";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";

export const CustomChartTick = ({ x, y, payload }: any) => {
  const { isMoreThanSm } = useBreakpoint();
  return (
    <g transform={`translate(${x},${y})`}>
      {isMoreThanSm ? (
        <NumericFormat
          value={Number(payload.value)}
          displayType={"text"}
          renderText={(value) => (
            <text
              x={0}
              y={0}
              dy={0}
              textAnchor="end"
              fill="#666"
              fontSize={"12px"}
              fontWeight={500}
              fontFamily={fontFamily.Axiforma}
            >
              {value}
            </text>
          )}
          decimalScale={2}
          fixedDecimalScale={true}
          thousandSeparator={true}
          prefix={"€"}
        />
      ) : (
        <NumericFormat
          value={Number(payload.value)}
          displayType={"text"}
          renderText={(value) => (
            <text
              x={0}
              y={0}
              dy={0}
              textAnchor="end"
              fill="#666"
              fontSize={"12px"}
              fontWeight={500}
              fontFamily={fontFamily.Axiforma}
            >
              {`${value.split("#")[0]}${
                (Number(value.split("#")[1]) || 0) > 999
                  ? `${
                      (Math.sign(Number(value.split("#")[1]) || 0) *
                        Math.round(Math.abs(Number(value.split("#")[1]) || 0) / 100)) /
                      10
                    }k`
                  : Number(value.split("#")[1])
              }`}
            </text>
          )}
          prefix={"€#"}
        />
      )}
    </g>
  );
};
